import Breadcrumb, { BreadcrumbItem } from '@ui/Breadcrumb';

export const BreadcrumbsAndTitle = ({
  items,
  title,
}: {
  items: BreadcrumbItem[];
  title: string;
}) => {
  return (
    <div className="mt-[6rem]">
      <div className="text-brand-secondary">
        <Breadcrumb items={items} />
      </div>
      <h1 className="mt-[1.6rem] text-[3rem] sm:text-[4.4rem] font-semibold">{title}</h1>
    </div>
  );
};
